import compact from 'lodash/compact'
import find from 'lodash/find'
import map from 'lodash/map'
import React, { useContext, useMemo } from 'react'

import { ProductContext } from '@Components/Product/Context'
import { BaseAttribute } from '@Generated/graphql'
import { useLocale } from '@Globals/Locale'
import { useTranslation } from '@Globals/Translations'

import styles from './ProductUSPsLegacy.module.scss'

export const ProductUSPsLegacy = ({ showPriceIsForOne = false }: { showPriceIsForOne?: boolean }) => {
  const locale = useLocale()
  const { t } = useTranslation()
  const product = useContext(ProductContext)

  const items = useMemo(() => {
    const uniqueSellingPoints = (
      (find(product?.masterVariant?.attributes, ['key', 'descriptionItems']) as BaseAttribute)?.value || []
    ) as Record<string, string>[]

    return compact([
      showPriceIsForOne && t('products:PP_PRICE_IS_FOR_ONE_PIECE'),
      ...map(uniqueSellingPoints, descriptionItem => descriptionItem[locale]),
    ])
  }, [locale, product?.masterVariant?.attributes, showPriceIsForOne, t])

  if (items.length === 0) {
    return null
  }

  return (
    <div className={styles.usps}>
      <ul className={styles.list}>
        {map(items, item => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  )
}
